import Card from "react-bootstrap/Card";

interface rankArray {
  name: string;
  perc: number;
}

interface cardProps {
  header: string;
  cardFunction?: any;
  selectedCard: string;
  first: rankArray[];
  second: rankArray[];
  third: rankArray[];
}

export default function CustomCard({
  header,
  cardFunction,
  selectedCard,
  first,
  second,
  third,
}: cardProps) {
  return (
    <Card
      className={
        first.length + second.length + third.length > 3
          ? "custom-card custom-card-height"
          : "custom-card "
      }
      style={{
        border:
          header === selectedCard
            ? "2px solid #56BBF1"
            : "1px solid rgba(0,0,0,0.125)",
      }}
      onClick={cardFunction}
    >
      <Card.Header className={"custom-card-head"}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          {header}
          <span style={{ fontSize: 12, textDecoration: "underline" }}>
            (View Table)
          </span>
        </div>
      </Card.Header>
      <Card.Body className="custom-card-body">
        <div>
          {first.map((i) => (
            <Card.Title className="custom-card-ranks" key={i.name}>
              <div>#1 {i.name}</div>
              <span>{i.perc.toFixed(1)}%</span>
            </Card.Title>
          ))}
        </div>
        <div>
          {second.map((i) => (
            <Card.Text className="custom-card-ranks" key={i.name}>
              <div>#2 {i.name}</div>
              <span>{i.perc.toFixed(1)}%</span>
            </Card.Text>
          ))}
        </div>
        <div>
          {third.map((i) => (
            <Card.Text className="custom-card-ranks" key={i.name}>
              <div>#3 {i.name}</div>
              <span>{i.perc.toFixed(1)}%</span>
            </Card.Text>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}
